import {useEffect, useState} from "react";
import {Progress} from "antd";
import ApiService from "../../core/service/api-service";
import {v4} from "uuid";

export default function ViewerPanel({src}) {
    const [height, setHeight] = useState(window.innerHeight - 90);

    useEffect(() => {
        const handleResize = () => {
            const isFullScreen = window.innerHeight === window.outerHeight;
            setHeight(!isFullScreen ? window.innerHeight - 90 : window.innerHeight);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <>
            <iframe
                id={'viewer_'}
                onLoad={(event) => {}}
                width={'100%'}
                height={height}
                src={src}
            />
        </>
    )
}